/* eslint-disable eqeqeq */
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import { Toast } from 'vant'
import {
  appid,
  appidFn,
  buriedpointpath,
  exclusiveidFn,
  getCookie,
  getQueryString,
  isWeixin,
  meetingidFn,
  setCookie,
  weChatAuthorization,
  publicParams,
  Base64,
  pointParams,
  objectDecode
} from '../assets/common/js/config'
import waptoken from '../assets/common/js/wapid'

Vue.use(Toast)

// 自建axios示例
var customRequestAjax = axios.create({
  method: 'get', // 默认是 get
  baseURL: 'https://ckysmall.ckc8.com/',
  timeout: 30000
})

// token: b24vxLk284D0QSyfzxne67jIeslkhtoatK105   000ckys000D0Zo0fvxGdaxIMBtlCIYckys000  b24qrOI284D0Q65n9xnG3fuGfsmMnUoatK105

// 添加请求拦截器
customRequestAjax.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    let params = {
      appid: appidFn() > -1 ? appidFn() : 1,
      tn: new Date().getTime(),
      token: appid,
      sign: new Date().getTime()
    }
    if (meetingidFn()) params.meetingid = meetingidFn()
    if (exclusiveidFn()) params.exclusiveid = exclusiveidFn()
    if (pointParams('&')) {
      let pointparams = objectDecode(pointParams('&'))
      params = { ...pointparams, ...params }
    }
    if (isWeixin()) {
      if (!getQueryString('pt') && getCookie('wxmalltoken')) {
        if (!getCookie('ndoresult')) {
          setCookie('ndoresult', getCookie('wxndoresult'))
        }
      } else {
        if (getQueryString('pt') == 'xcx' && getQueryString('token')) {
          params.appid = 4
          if (sessionStorage.getItem('scene'))
            params.scene = sessionStorage.getItem('scene')
          if (publicParams('deviceid'))
            params.deviceid = publicParams('deviceid')
        } else if (getQueryString('orgtype')) {
          params.appid = 1
        } else {
          weChatAuthorization()
        }
      }
    } else {
      if (getQueryString('pt') == 'app' && getQueryString('token')) {
        params.appid = 2
        if (publicParams('deviceid')) params.deviceid = publicParams('deviceid')
      } else if (getQueryString('pt') == 'ckapp' && getQueryString('token')) {
        /*
         * 修改时间：2021/1/25
         * 公共参数兼容创客app3.0以及4.0
         */
        if (getQueryString('v') == '4.0') {
          params.appid = 5
          params.v = 4
          if (publicParams('deviceid'))
            params.deviceid = publicParams('deviceid')
        } else {
          params.appid = 5
          if (getQueryString('ckid')) {
            let base = new Base64()
            params.cktoken = base.encode(getQueryString('ckid'))
          } else if (getQueryString('cktoken')) {
            params.cktoken = getQueryString('cktoken')
          }
          if (publicParams('deviceid'))
            params.deviceid = publicParams('deviceid')
        }
      } else {
        var wapid = waptoken.waptoken
        params.appid = 3
        params.token = wapid
      }
    }

    if (config.method == 'get') {
      config.params = { ...params, ...config.params }
    } else if (config.method == 'post') {
      config.data = { ...config.data, ...params }
      config.data = qs.stringify(config.data)
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
customRequestAjax.interceptors.response.use(
  function(res) {
    // 对响应数据做点什么
    if (
      res.config.url.indexOf('Wxmall/Sysinfo/actNotice') <= -1 &&
      res.config.url.indexOf(buriedpointpath) <= -1 &&
      res.config.url.indexOf('Wxmall/Address/checkAddress') <= -1 &&
      res.config.url.indexOf('Wxmall/StoreChange/webcheckUserinfo') <= -1 &&
      res.config.url.indexOf('Wxmall/Share/getCurrencyShare') <= -1 &&
      res.config.url.indexOf('Wxmall/Trusteeship/addTrusteeshipUserRecord') <=
        -1 &&
      res.config.url.indexOf('Wxmall/Integralmall/userSign') <= -1 &&
      res.config.url.indexOf('Wxmall/Integralmall/signIn') <= -1
    ) {
      if (res.config.url.indexOf('Wxmall/ShoppingCart/getShoppingCart') > -1) {
        if (
          res.data.code != 200 &&
          res.data.code != 10000 &&
          res.data.code != 2000
        ) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else if (
        res.config.url.indexOf('Wxmall/Activity/getCkCommunityActList') > -1
      ) {
        if (
          res.data.code != 200 &&
          res.data.code == 5001 &&
          res.data.code != 2000
        ) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else if (
        res.config.url.indexOf('Wxmall/OrderRefund/checkOrderRefund') > -1 ||
        res.config.url.indexOf('Wxmall/OrderRefund/addApplyOrder') > -1
      ) {
        if (
          res.data.code != 200 &&
          res.data.code != 6006 &&
          res.data.code != 6007 &&
          res.data.code != 2000
        ) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else if (
        res.config.url.indexOf('Wxmall/DrainageAct/getActJoinStatus') > -1
      ) {
        if (
          res.data.code != 200 &&
          res.data.code != 201 &&
          res.data.code != 202 &&
          res.data.code != 2000
        ) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else if (
        res.config.url.indexOf('Wxmall/CommunityPosts/addPosts') > -1
      ) {
        if (res.data.code != 200 && res.data.code != 5001) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else if (
        res.config.url.indexOf('Wxmall/Order/checkGetMeetingsPrizes') > -1
      ) {
        if (res.data.code != 200 && res.data.code != 2001) {
          if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      } else {
        if (res.data.code != 200 && res.data.code != 2000) {
          if (
            res.config.data &&
            res.config.data.indexOf('custom_msg_kk') >= 0
          ) {
          } else if (res.data.msg) {
            Toast(res.data.msg)
          }
        }
      }
    }
    return res
  },
  function(error) {
    // 对响应错误做点什么
    // Toast.clear()
    // Toast('网络错误')
    return Promise.reject(error)
  }
)

export { customRequestAjax }



// WEBPACK FOOTER //
// ./src/axiosApi/index.js